(function(window, document) {
  'use strict';

  var MODULE_NAME = 'TPBDualFulfillmentStatus';
  var SOURCE_BRASIL = 'brasil';
  var SOURCE_INTERNACIONAL = 'internacional';

  function isSupportedSource(source) {
    return source === SOURCE_BRASIL || source === SOURCE_INTERNACIONAL;
  }

  function applyCopy(root, source) {
    if (!root) return;

    root.querySelectorAll('[data-tpb-fulfillment-copy]').forEach(function(element) {
      var nextText = source === SOURCE_INTERNACIONAL
        ? element.dataset.internacional
        : element.dataset.brasil;

      if (typeof nextText === 'string') {
        element.textContent = nextText;
      }
    });
  }

  function applyIcons(root, source) {
    if (!root) return;

    root.querySelectorAll('[data-tpb-fulfillment-icon]').forEach(function(icon) {
      icon.hidden = icon.dataset.tpbFulfillmentIcon !== source;
    });
  }

  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.dualFulfillment !== 'true') return;
    if (wrapper.dataset.preorderEnabled === 'true') return;
    if (wrapper.dataset.fulfillmentStatusReady === 'true') return;

    wrapper.dataset.fulfillmentStatusReady = 'true';

    var card = wrapper.querySelector('[data-tpb-shipping-card]');
    var modal = wrapper.querySelector('#modal-envio-local') || document.getElementById('modal-envio-local');
    var inlineNotice = wrapper.querySelector('[data-tpb-inline-shipping-notice]');

    if (!card || !modal) {
      console.warn('[' + MODULE_NAME + '] 未找到配送状态卡或配送弹窗，动态文案模块已跳过。');
      return;
    }

    function applyState(detail) {
      var variant = detail && detail.variant;
      var source = detail && detail.source;
      var isAvailable = Boolean(variant && variant.available);

      // 没有可售的真实变体时，隐藏配送卡，避免显示错误来源。
      if (!isAvailable || !isSupportedSource(source)) {
        card.hidden = true;
        if (inlineNotice) inlineNotice.hidden = true;
        wrapper.dataset.fulfillmentDisplayOrigin = '';
        return;
      }

      applyCopy(card, source);
      applyIcons(card, source);
      applyCopy(modal, source);
      applyIcons(modal, source);
      if (inlineNotice) {
        applyCopy(inlineNotice, source);
        inlineNotice.hidden = source !== SOURCE_INTERNACIONAL;
      }

      card.hidden = false;
      card.setAttribute(
        'aria-label',
        source === SOURCE_INTERNACIONAL
          ? 'Envio internacional: entrega estimada em 12 a 20 dias'
          : 'Envio local: estoque no Brasil'
      );

      modal.dataset.activeFulfillment = source;
      wrapper.dataset.fulfillmentDisplayOrigin = source;
    }

    wrapper.addEventListener('tpb:dual-fulfillment-resolved', function(event) {
      applyState(event.detail || {});
    });
  }

  function init() {
    document.querySelectorAll('.tpb-pdp-wrapper').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(window, document);
